import { IStage } from '@forwardflow/store/onboardingStoreV2'
import { Stack } from '@forwardflow/ui-v2'
import { StageInput } from '@forwardflow/modules/onboarding'

export const StageInputList = ({
   stages,
   shouldAddDescription,
   onChange,
   onRemoveStage,
}: {
   stages: IStage[]
   shouldAddDescription?: boolean
   onChange?: (stage: IStage, index: number) => void
   onRemoveStage?: (index: number) => void
}) => {
   return (
      <Stack gap={4}>
         {stages.map((stage, index) => (
            <StageInput
               key={index.toString()}
               index={index}
               shouldAddDescription={shouldAddDescription}
               value={{
                  id: stage.id,
                  name: stage.name,
                  description: stage.description,
                  type: stage.type || 'stage',
               }}
               onChange={(value) => {
                  console.log('value', value)
                  onChange?.(
                     {
                        id: value?.id || '',
                        name: value?.name || '',
                        description: value?.description || '',
                        type: value?.type || 'stage',
                     },
                     index
                  )
               }
               }
               shouldShowRemove={stages.length > 1}
               onRemove={(index) => onRemoveStage?.(index)}
            />
         ))}
      </Stack>
   )
}
